import { Typography, XStack } from '@shinetools/lumen-react'
import { ReactNode } from 'react'

interface DetailRowProps {
  children: ReactNode
  label: string
}

export const DetailRow = ({ children, label }: DetailRowProps) => (
  <XStack align="baseline" gap={8} wrap="wrap">
    <Typography.Text color="var(--lumen-color-content-neutral-medium)">{label}</Typography.Text>
    <Typography.Text>{children}</Typography.Text>
  </XStack>
)
